import {IVisualDataStreamer} from '@mintdata-wsp/wsp/controllers/visualDesigner/visualData/VisualDataStreamer';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {OnToolbarClick, Toolbar, ToolbarItem} from '@mintdata-wsp/wsp/ui/components/general/Toolbar';
import {PanelContentProps} from '@mintdata-wsp/wsp/ui/views/visualDesigner/general/layout/PanelView';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./DebugDataTopBar.less');
const cx = classnames.bind(styles);

export interface DebugDataTopBarProps extends PanelContentProps
{
    label:string;
    toolbarItems:ToolbarItem[];
    streamer:IVisualDataStreamer;
    onToolbarClick:OnToolbarClick;
}

@observer
export class DebugDataTopBar extends React.Component<DebugDataTopBarProps, any>
{

    // @bind
    // private _renderColumnNames()
    // {
    //     const {streamer} = this.props;
    //     streamer.getGridModel().getNumColumns();
    //
    //     const columnNames = streamer.getGridModel().getColumnNames();
    //
    //     return  <div>
    //             {
    //                 columnNames.map((name:string)=>
    //                 {
    //                     return <div>name</div>;
    //                 })
    //             }
    //             </div>;
    // }

    render()
    {
        const {label, toolbarItems, onToolbarClick} = this.props;

        return  <Row className={cx('debugDataTopBar')}>

                    <div className={cx('label')}>{label}</div>
                    <Toolbar items={toolbarItems} onClick={onToolbarClick}/>

                </Row>;
    }
}
